import { render, staticRenderFns } from "./Brokerageagent.vue?vue&type=template&id=406fc680&"
import script from "./Brokerageagent.vue?vue&type=script&lang=js&"
export * from "./Brokerageagent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports